import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';
// ! component
import { AboutkypageComponent } from './pages/aboutpages/aboutkypage/aboutkypage.component';
import { CopyrightComponent } from './pages/claims/copyright/copyright.component';
import { InfoSecurityComponent } from './pages/claims/info-security/info-security.component';
import { PrivacyComponent } from './pages/claims/privacy/privacy.component';
import { ContactUsComponent } from './pages/contact-us/contact-us.component';
import { CorporatePhilosophyComponent } from './pages/corporate-philosophy/corporate-philosophy.component';
import { IndexComponent } from './pages/index/index.component';
import { NewsCenterComponent } from './pages/news/news-center/news-center.component';
import { NewsComponent } from './pages/news/news/news.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { ProductComponent } from './pages/products/product/product.component';
import { ProductsComponent } from './pages/products/products/products.component';
import { HumanRecruitComponent } from './pages/recruitpages/human-recruit/human-recruit.component';
import { SolutionExploreComponent } from './pages/solutions/solution-explore/solution-explore.component';
import { SolutionsComponent } from './pages/solutions/solutions/solutions.component';
import { SuccessComponent } from './pages/solutions/success/success.component';
import { PsirtComponent } from './pages/psirt/psirt.component';

const routes: Routes = [
    // ** web 2.0
    { path: '', component: IndexComponent, data: { title: '首頁' } },
    {
        path: 'aboutKunYu',
        component: AboutkypageComponent,
        data: { title: '關於坤侑' },
    },
    {
        path: 'newsCenter',
        component: NewsCenterComponent,
        data: { title: '新聞中心' },
    },
    {
        path: 'humanRecruit',
        component: HumanRecruitComponent,
        data: { title: '人才招募' },
    },
    { path: 'newsCenter/:type/:title', component: NewsComponent },
    {
        path: 'products',
        component: ProductsComponent,
        data: { title: '產品服務' },
    },
    { path: 'products/:title', component: ProductComponent },
    {
        path: 'solutions',
        component: SolutionsComponent,
        data: { title: '解決方案' },
    },
    { path: 'solutions/explore/:keyword', component: SolutionExploreComponent },
    {
        path: 'solutions/explore',
        component: SolutionExploreComponent,
        data: { title: '各個領域的解決方案' },
    },
    { path: 'success/:title', component: SuccessComponent },
    { path: 'privacy', component: PrivacyComponent },
    { path: 'infoSecurity', component: InfoSecurityComponent },
    { path: 'copyright', component: CopyrightComponent },
    { path: 'corporatePhilosophy', component: CorporatePhilosophyComponent },
    { path: 'psirt', component: PsirtComponent },
    {
        path: 'contactUs',
        component: ContactUsComponent,
        data: { title: '聯絡我們' },
    },
    {
        path: 'page-not-found',
        component: PageNotFoundComponent,
        data: { title: '頁面不存在' },
    },
    { path: '**', redirectTo: 'page-not-found' },
];

@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        RouterModule.forRoot(routes, {
            scrollPositionRestoration: 'top',
        }),
    ],
    exports: [],
})
export class AppRoutingModule {}
